import React from 'react';
import { connect } from 'react-redux';

import { setCurrentlyPlaying, toggleAudio, closePlayer, nextAudioFile, prevAudioFile } from '../../../actions/tourActions';
import PointTitleBar from './PointTitleBar';
import PointAudioButtons from './PointAudioButtons';


const mapStateToProps = (state) => {
    return {
        currentlyPlaying: state.currentlyPlaying,
        currentTour: state.currentTour,
        isAudioPlaying: state.isAudioPlaying
    }
};

const mapDispatchToProps = (disptach) => {
    return {
        setCurrentlyPlaying: (audio) => disptach(setCurrentlyPlaying(audio)),
        toggleAudio: (val) => disptach(toggleAudio(val)),
        closePlayer: () => disptach(closePlayer()),
        nextAudioFile: (audio) => disptach(nextAudioFile(audio)),
        prevAudioFile: (audio) => disptach(prevAudioFile(audio))
    }
}



class PointAudioPlayer extends React.Component {

    constructor(props) {
        super(props);
        console.log(props);
        this.playAudio = this.playAudio.bind(this);
        this.playerMode = this.playerMode.bind(this);
        this.closePlayer = this.closePlayer.bind(this);
        this.playNextTrack = this.playNextTrack.bind(this);
        this.playPrevTrack = this.playPrevTrack.bind(this);
    }
    
    playerMode() {
        console.log('change player mode');
    }

    closePlayer() {
        this.props.closePlayer();
    }


    playAudio() {
        const audioState = this.props.isAudioPlaying === true ? false : true;
        this.props.toggleAudio(audioState);
    }

    playNextTrack(){
        this.props.toggleAudio(false);
        const {currentlyPlaying,currentTour} = this.props;        
        const {interesting_locations} = currentTour.acf;
        const indexCurrentlyPlaying = interesting_locations.indexOf(currentlyPlaying.postData);

        let newItem = null;
        if(indexCurrentlyPlaying >= interesting_locations.length -1){
            newItem = interesting_locations[0]
        }
        else{
            newItem = interesting_locations[indexCurrentlyPlaying+1]
        }
        
        console.log(newItem);
        this.props.nextAudioFile(newItem);
    }

    playPrevTrack(){
        this.props.toggleAudio(false);
        const {currentlyPlaying,currentTour} = this.props;        
        const {interesting_locations} = currentTour.acf;
        const indexCurrentlyPlaying = interesting_locations.indexOf(currentlyPlaying.postData);

        let newItem = null;
        if(indexCurrentlyPlaying === 0){
            newItem = interesting_locations[interesting_locations.length - 1]
        }
        else{
            newItem = interesting_locations[indexCurrentlyPlaying - 1]
        }
        
        console.log(newItem);
        this.props.nextAudioFile(newItem);
    }

    render() {
        const { isAudioPlaying, currentlyPlaying } = this.props;
        const slideClass = 'app-point-container-modal animated bounceInUp';

        const styles = {
            position: 'fixed',
            zIndex: 3,
            //border: '2px solid red',
            top: 0,
            left: 0,
            width: '100%',
            backgroundImage: `url(${this.props.currentlyPlaying.banner})`,
            backgroundColor: '#ccc',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '50% 50%',
            backgroundSize: 'cover',
            height: '100%'
        }
        console.log(currentlyPlaying);
        return (
            <div>
                {currentlyPlaying.audioFile !== null ? <div className={slideClass} style={styles}><PointTitleBar
                    title="testing"
                    subTitle="this is a test"
                    currentlyPlaying={currentlyPlaying}
                    onClosePlayer={this.closePlayer}
                    onPlayerMode={this.playerMode} />
                    <PointAudioButtons
                        audioFile={currentlyPlaying.audioFile}
                        onPlayAudio={this.playAudio}
                        onPlayPrevTrack={this.playPrevTrack}
                        onPlayNextTrack={this.playNextTrack}
                        isAudioPlaying={isAudioPlaying} />
                </div> : null
                }
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PointAudioPlayer);


// WEBPACK FOOTER //
// ./src/components/shared/PointAudio/PointAudioPlayer.js